function isFiniteValue(n: number): boolean {
    return !isNaN(n) && isFinite(n);
}

function parseNumberOrNull(str: string) {
    const trimmed = str.trim();
    if (trimmed === "") {
        return null;
    }
    const value = Number(str);
    return isFiniteValue(value) ? value : null;
}

export { parseNumberOrNull, isFiniteValue };
